import styled from 'styled-components';

const ScreenContainer = styled.div`
    padding: 1rem;
`;

export default ScreenContainer;
